module.exports = __webpack_public_path__ + "img/faqs_layout1.46f44d54.png";